import { render } from "./ProjectEditingCore.vue?vue&type=template&id=3cc058b6"
import script from "./ProjectEditingCore.vue?vue&type=script&lang=js"
export * from "./ProjectEditingCore.vue?vue&type=script&lang=js"
script.render = render

export default script